import Cookies from 'js-cookie';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Img_profile from '~/settings/__modules__/images/img_profile.png';

const lang = Cookies.get('language') ?? Cookies.get('LC') ?? 'en_US';
const COLORS = ['#8BCB99', '#83BEB7', '#9ACCD7', '#7FB8D9', '#86A4D4'];

const getBgColor = (userNo) => {
  const colorLen = COLORS.length;
  let colorIdx = 0;
  try {
    colorIdx = parseInt(((userNo / 131) % colorLen) + '');
  } catch (error) {
    // empty
    console.error(error);
  }
  return COLORS[colorIdx];
};

const getFirstChar = (userName = '') => {
  const firstChar = userName.length > 0 ? userName[0] : '';
  const text = firstChar.toUpperCase();
  return text;
};

Avatar.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  userName: PropTypes.string,
  userNo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export function Avatar({ imgSrc, userName, userNo }) {
  const [showImg, setShowImg] = useState(true);

  const createAvatar = () => {
    if (!userNo || !userName) {
      return <img src={Img_profile} alt="" />;
    }
    return (
      <span
        lang={lang}
        className="initial_profile"
        style={{ backgroundColor: getBgColor(userNo) }}
      >
        <em>{getFirstChar(userName)}</em>
      </span>
    );
  };

  return (
    <>
      {showImg ? (
        <img
          src={imgSrc}
          alt="profile"
          onError={() => {
            setShowImg(false);
          }}
        />
      ) : (
        <>{createAvatar()}</>
      )}
    </>
  );
}
